import { Pipe, PipeTransform } from '@angular/core';
import { ColumnComplexTable } from '../complex-table.const';

@Pipe({
  name: 'canUpdateRow',
  pure: false,
  standalone: false,
})
export class CanUpdateComplextRowPipe implements PipeTransform {
  transform(record: Record<any, any>, column: ColumnComplexTable, _rowChanges: Record<any, any>): boolean {
    if (typeof column.editable === 'function') {
      const rowChange = Object.entries(_rowChanges).reduce(
        (acc, [key, change]: [string, any]) => ({ ...acc, [key]: change.value }),
        {}
      );
      const _row = { ...record, ...rowChange };
      return column.editable(_row, column as any);
    }
    return column?.editable;
  }
}
